import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useStyle = makeStyles({
	transform270Deg: {
		transform: 'rotate(270deg)',
	},
	backgroundColor: {
		backgroundColor: tokens.colorNeutralBackground1,
	},
	explorerDimension: {
		width: '100%',
		height: '100%',
	},
	explorerCollapsed: {
		...shorthands.margin('20px', 0, 0),
		fontWeight: tokens.fontWeightSemibold,
	},
	textOverFlowElipsis: {
		...shorthands.overflow('hidden'),
		textOverflow: 'ellipsis',
		width: '100%',
	},
	flex: {
		display: 'flex',
		justifyContent: 'space-between',
	},
	marginTop8: {
		...shorthands.margin('8px', 0, 0, 0),
	},
});

export default useStyle;
